import { render, staticRenderFns } from "./FilmsNews.vue?vue&type=template&id=5ba196f7&scoped=true&"
import script from "./FilmsNews.vue?vue&type=script&lang=js&"
export * from "./FilmsNews.vue?vue&type=script&lang=js&"
import style0 from "./FilmsNews.vue?vue&type=style&index=0&id=5ba196f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba196f7",
  null
  
)

export default component.exports